module.exports = __webpack_public_path__ + "static/media/as.816a1aee.svg";